import { useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";

function systemPrefersDark(): boolean {
  return matchMedia("(prefers-color-scheme: dark)").matches;
}

function applyFavicon(dark: boolean) {
  const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link) link.setAttribute("href", dark ? "/assets/icon-dark.svg" : "/assets/icon.svg");
}

function apply(theme: Theme) {
  const dark = theme === "dark" || (theme === "system" && systemPrefersDark());
  document.documentElement.classList.toggle("dark", dark);
  applyFavicon(dark);
}

export function getStoredTheme(): Theme {
  const v = localStorage.getItem("theme");
  return v === "light" || v === "dark" ? v : "system";
}

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(getStoredTheme);

  useEffect(() => {
    apply(theme);
    if (theme === "system") {
      const mq = matchMedia("(prefers-color-scheme: dark)");
      const onChange = () => apply("system");
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    }
  }, [theme]);

  const setTheme = (t: Theme) => {
    if (t === "system") localStorage.removeItem("theme");
    else localStorage.setItem("theme", t);
    setThemeState(t);
  };

  return { theme, setTheme };
}
